import React, {useState} from 'react'
import { useHistory } from "react-router";
import {Form, Label, Button, InputGroup, FormControl} from 'react-bootstrap'
import logoIcon from '../../assets/images/logo-full.svg'
import {NavLink} from "react-router-dom"
import {useForm} from "react-hook-form"
import {EmptyLocalStorage, Login} from "../../services/auth/auth.service"
import {constants} from "../../utils/constants";
import {toast} from "react-toastify";
import {FaEye, FaEyeSlash} from "react-icons/fa";

function Signin() {
    const history = useHistory();
    const [pass, TogglePass] = useState(true);

    const {register, handleSubmit, watch, formState: {errors}} = useForm({
        mode: "onChange"
    });

    const onSubmit = async (data) => {
        await Login(data.email, data.password, data.role_id, 'web', 'xyz').then((data) => {
            if (data.status) {
                if(data.data.roles[0].id == constants.ROLES.ROLE_ADMIN){
                    toast.success(data.message);
                    history.push('/dashboard')
                }
                else{
                    toast.error("You are not allowed to access admin panel");
                }
            }
            else{
                toast.error(data.message);
            }
        }).catch((error) => {
            if (error.response.status == 401) {
                EmptyLocalStorage()
                history.push('/');
            } else {
                return toast.error(error.response.data.message);
            }
        })
    };

    return (
        <div className={"text-center authLayout"}>
            <Form className={"form-signin"} onSubmit={handleSubmit(onSubmit)}>
                <a href="/">
                    <img className="img-fluid mb-4" src={logoIcon} alt="Imprint Logo" title="Imprint Logo" style={{padding: "10px 25px"}}/>
                </a>
                <h1 className="h6 mb-3 font-weight-normal">Sign in to your account</h1>
                <Form.Group className="mb-3">

                    <Form.Control
                        placeholder="Email address"
                        id={"formSignInEmail"}
                        {...register('email', {
                            required: {
                                value: "required",
                                message: "Email is required"
                            },
                            maxLength: {
                                value: 255,
                                message: "Max length is 255"
                            },
                            pattern: {
                                value: /\S+@\S+\.\S+/,
                                message: "Entered value does not match email format"
                            }
                        })}
                        type="email"
                    />
                    {errors.email &&
                    <span className={"validation-error pr-5"} role="alert">{errors.email.message}</span>}

                    {/*password*/}
                    <div className={"pass-field"}>
                        <InputGroup controlId="passowrd">
                            <FormControl
                                placeholder="Enter Password"
                                autoComplete={"off"}
                                {...register('password', {
                                    minLength: {
                                        value: 8,
                                        message: "Min length is 8"
                                    },
                                    maxLength: {
                                        value: 255,
                                        message: "Max length is 255"
                                    }
                                })}
                                type={pass ? "password" : "text"}/>
                            <Button variant="outline-secondary" id="button-addon2" onClick={() => TogglePass(!pass)}>
                                {
                                    pass ? <FaEye /> :  <FaEyeSlash />
                                }
                            </Button>
                        </InputGroup>
                        {errors.password &&
                        <span className={"validation-error pr-5"} role="alert">{errors.password.message}</span>}
                    </div>
                    {/*password*/}

                </Form.Group>


                <ul className={"list-unstyled mt-3 d-block"}>
                    <li className={"d-block text-end"}>
                        <NavLink to={"/forgot-password"}>
                            Forgot Password
                        </NavLink>
                    </li>
                </ul>
                <div className="d-grid gap-2">
                    <Button variant="primary" size="lg" type="submit" className={"btn-green-theme text-uppercase"}>
                        Sign In
                    </Button>

                </div>
                <p className="mt-5 mb-3 text-muted">&copy; All rights reserved by OurChat Inc.</p>
            </Form>
        </div>
)
}

export default Signin
